<template>
  <div>
    <!-- Menu lewe -->
    <v-navigation-drawer clipped app v-model="drawer">
      <v-list dense>
        <template 
          v-for="item in menuItems"
          >
          <v-row 
            v-if="item.heading" :key="item.heading" 
            align="center"
            v-show="item.prod==1 && (customer.permissions >= item.min_permissions || !item.min_permissions)"
          >
            <v-col cols="6">
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-col>
            <v-col cols="6" class="text-center">
              <a href="#!" class="body-2 black--text"></a>
            </v-col>
          </v-row>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-show="item.prod==1 && (customer.permissions >= item.min_permissions || !item.min_permissions)"
            :v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon="mdi-chevron-down"
          > 
            <template v-slot:activator @click="item.model = !item.model">
              <v-list-item  class="pa-0">
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>

            <v-list-item
              v-for="(child, i) in item.children"
              v-show="child.prod==1 && (customer.permissions >= child.min_permissions || !child.min_permissions)"
              :key="i"
              link
              @click="moveTo(child.link)"
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title
                  class="ml-4"
                  v-text="child.text"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-item 
            v-else :key="item.text" 
            v-show="item.prod==1 && (customer.permissions >= item.min_permissions || !item.min_permissions)"
            link 
            @click="moveTo(item.link)"
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <!-- Pasek menu u góry -->
    <v-app-bar clipped-left app color="primary" dark>
      <!--Nazwa za rozwijanym menu  -->
      <v-toolbar-title style="width: 45px">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      </v-toolbar-title>
     
      <!-- <span>
        <v-img src="@/assets/logo_200.png" alt="logo"  ></v-img>
      </span> -->
      <v-spacer />
      <!-- Menu prawe -->
      <v-menu
        v-model="menu"
        :close-on-content-click="true"
        :nudge-width="200"
        offset-y
      >
        <template v-slot:activator="{ on: menud }">
          
          <v-tooltip bottom :disabled="menu">
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                class="mx-2 secondary"
                fab
                dark
                small
                v-on="tooltip"
                @click="menuOn"
              >
                {{ inicials(customer.personName) }}
                <!-- <span>{{ custSign }}</span> -->
              </v-btn>
            </template>
            <p class="title" style="margin: 0px">{{ customer.personName }}</p>
            <p class="caption">{{ customer.email }}</p>
          </v-tooltip>
        </template>

        <v-card>
          <v-list>
            <v-list-item>
              <v-list-item-avatar>
                <v-btn class="mx-2 secondary" fab dark small>
                  <span>{{ inicials(customer.personName) }}</span>
                </v-btn>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>{{ customer.personName }}</v-list-item-title>
                <v-list-item-subtitle>
                  {{ customer.email }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>

          <v-list dense>
            <!-- <v-subheader>OPCJE</v-subheader> -->
            <v-list-item-group v-model="menu" color="primary">
              <v-list-item v-for="(item, i) in rightMenuItems" :key="i">
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>

          <!--  <v-divider></v-divider> -->

            <v-list-item  style="margin: 5px 0px 0px ">
              <v-btn block dark class="blue-grey ma-0"  @click="changePassword">
                {{ $t("Menu.rightMenu.ChangePassword") }}
                <v-icon right dark>mdi-key-change</v-icon>
              </v-btn>
            </v-list-item>
            <!-- <v-list-item style="margin: 4px 0px 0px ">
              <v-btn block dark class="red darken-4"  @click="logout">{{
                $t("Menu.rightMenu.Logout")
              }}</v-btn>
            </v-list-item> -->
          </v-list>
        </v-card>
      </v-menu>

      <Language />
      <SessionTime class="px-2"/>


        <v-dialog v-model="dialogChangePassword" max-width="400">
          <v-card>
            <v-card-title class="headline">{{
              $t("ResetPasswordForm.FormTopic")
            }}</v-card-title>
            <v-card-text>
              <v-form ref="ResetPasswordForm">
                <v-text-field
                  :label="label_oldPassword"
                  prepend-icon="mdi-key-outline"
                  v-model="oldPassword"
                  id="oldPassword"
                  name="oldPassword"
                  type="password"
                  required
                  :rules="rules_oldPassword"
                  autofocus 
                ></v-text-field>
                <v-text-field
                  :label="label_newPassword"
                  prepend-icon="mdi-lock-outline"
                  v-model="newPassword"
                  id="newPassword"
                  name="newPassword"
                  required
                  :rules="rules_newPassword"
                  :append-icon="disableBtnChangePasswordShow ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="disableBtnChangePasswordShow ? 'password' : 'text'"
                  @click:append="() => (disableBtnChangePasswordShow = !disableBtnChangePasswordShow)"
                ></v-text-field>
                <v-text-field
                  :label="label_confirmPassword"
                  prepend-icon="mdi-lock-outline"
                  v-model="confirmPassword"
                  id="confirmPassword"
                  name="confirmPassword"
                  required
                  :type="disableBtnChangePasswordShow ? 'password' : 'text'"                  
                  :rules="[rules_confirmPassword, rules_confirmPasswordCheckMatch]"
                  
                ></v-text-field>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text color="error" @click="dialogChangePassword = false">{{
                  $t("Close")
                  }}</v-btn>
                  <v-btn 
                    :loading="loadingBtn"
                    :disabled="disableBtnChangePassword"
                    text color="primary" 
                    @click="BtnSendPasswordReset">{{
                    $t("Change")
                  }}
                  </v-btn>
                </v-card-actions>
             </v-form>
            </v-card-text>
            
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogExpiredSession" max-width="300">
          <v-card>
            <v-card-title>
            </v-card-title>
           <v-card-text>
              <v-form ref="ExtendSesssionForm">
                <v-card class="elevation-0">
                  <span class="caption">
                    <v-icon>mdi-clock</v-icon>
                    {{ $t("Session.SessionWillExpired") }} 
                    </span>
                  <span class="headline row align-center justify-center pt-5">{{ countDownStr }}</span>
                  <span></span>
                  <span class="caption  row align-center justify-center py-8">{{ $t("Session.Alert1") }} </span>
                <v-card-actions>
                  <v-btn 
                    :loading="loadingBtn"
                    @click="BtnExtendSessions"
                    block 
                    dark
                    color="green"
                  >
                    {{ $t("Session.ExtendSession") }}
                  </v-btn>
                </v-card-actions>
                </v-card>
             </v-form>
            </v-card-text>
            
          </v-card>
        </v-dialog>

    </v-app-bar>

    <slot />

    <!-- Stopka -->
    <v-footer dark color="primary" app>
        <div
       class="white--text caption "
        style="text-h1"
      >{{ PKVersion}}
      </div><v-spacer />
      <a
        style="text-decoration: none"
        target="_blank"
        href="https://www.termoprofil.eu"
      >
        <span class="white--text">Termo Profil &copy;{{ new Date().getFullYear() }}</span>
      </a>

      <v-spacer />
      <a
        style="text-decoration: none"
        target="_blank"
        href="https://pl-pl.facebook.com/termoprofil.eu/"
      >
        <v-icon color="grey">mdi-facebook-box</v-icon>
      </a>
      <a
        style="text-decoration: none"
        target="_blank"
        href="https://www.termoprofil.eu"
      >
        <v-icon color="grey">mdi-web</v-icon>
      </a>
    </v-footer>

     <v-snackbar v-model="snack" :timeout="2000" :color="snackColor">
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
      </v-snackbar>
  </div>
      
</template>

<script>
import Language from "@/components/Language.vue";
import SessionTime from "@/components/SessionTime.vue";

export default {
  props: {
    source: String
  },
  components: {
    Language,
    SessionTime
  },
  data: () => ({
    // -- menu prawe
    PKVersion: "PK v.1.0.9b",
    menu: false,
    menud: true,
    tooltip: true,
    message: false,
    hints: true,
    loadingBtn: false,
    dialogChangePassword: false,
    dialogExpiredSession: false,
    dialogExpiredSessionTime: 10, //czas trwania sesji - minuty
    countDown : 0,
    countDownStr : "",
    startCountDown : false,
    // -----
    showinfo: false,
    dialog: false,
    drawer: null,
    customer: {
      companyName: "",
      personName: "",
      email: "",
      permissions: null
    },
    userPassword: "",
    disableBtnChangePassword: true,
    disableBtnChangePasswordShow: true,
    snack: false,
    snackColor: "",
    snackText: "",    

    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
    
    rules_oldPassword: [
      value => !!value || "Pole wymagane",
      value => {
        return value == value || "Invalid password.";
      }
    ],
    rules_newPassword: [
      value => !!value || "Pole wymagane",
      value => /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/.test(value) || 'Min. 8 znaków z co najmniej jedną wielką literą, liczbą i znakami specjalnymi.',
      value => {
        return value == value || "Invalid password.";
      }
    ],
    rules_confirmPassword: [
      value => !!value || "Pole wymagane",
      value => {
        return value == value || "Invalid password.";
      }
    ],
    
    events: ['click','mousemove'],
    tokenTimer: null,
    logoutTimer: null,
    sessionExpiredToken: null,
    screenOrientation: ""
    

  }),
  
  computed: {
    custSign: function() {
      return this.customer.personName.substring(0, 2);
    },
    label_oldPassword: function() {
      return this.$t("ResetPasswordForm.OldPassword");
    },
    label_newPassword: function() {
      return this.$t("ResetPasswordForm.NewPassword");
    },
    label_confirmPassword: function() {
      return this.$t("ResetPasswordForm.ConfirmPassword");
    },
    rules_confirmPasswordCheckMatch() {
      return () => (this.newPassword === this.confirmPassword) || 'Hasła muszą być takie same'
    },
    menuItems: function() {
      return [
        {
          icon: "mdi-home-outline",
          text: this.$t("Menu.mainMenu.Dashboard"),
          link: "/",
          prod: 1, // Jeśli 1 to pojawia się w menu. Przydatne przy pracach nad dodatkowym menu
        },
        {
          icon: "mdi-receipt",
          text: this.$t("Menu.mainMenu.Invoices"),
          link: "/Invoices",
          prod: 1,
          min_permissions: 3 // Minimalne uprawnienia, konieczne do wyswietlenia danego menu
        },
        
        {
          icon: "mdi-cellphone-iphone",
          "icon-alt": "mdi-newspaper",
          text: this.$t("Menu.mainMenu.Complaints.Topic"),
          model: false,
          prod: 1,
          children: [
            {
              icon: "mdi-newspaper-plus",
              text: this.$t("Menu.mainMenu.Complaints.NewComplaint"),
              link: "/NewComplaint",
              prod: 1
            },
            {
              icon: "mdi-format-list-numbered",
              text: this.$t("Menu.mainMenu.Complaints.List"),
              link: "/ComplaintsList",
              prod: 1,
            }
          ]
        },
        {
          icon: "mdi-animation-outline",
          text: this.$t("Menu.mainMenu.ProductionTerms.Topic"),
          link: "/ProductionTerms",
          model: false,
          prod: 1
        },
        {
          icon: "mdi-download",
          text: this.$t("Menu.mainMenu.Downloads.Topic"),
          link: "/Downloads",
          model: false,
          prod: 1,
          min_permissions: 3 // Minimalne uprawnienia, konieczne do wyswietlenia danego menu
        },
        
        // { heading: "Inne" },
        // {
        //   icon: "mdi-chevron-up",
        //   'icon-alt': "mdi-chevron-down",
        //   text: "MenuDodatkowe",
        //   model: false,
        //   children: [
        //     { icon: "mdi-parachute-outline", text: "opcja 1", link: "/Test" },
        //     { icon: "mdi-chart-bell-curve", text: "opcja 2" }
        //   ]
        // },
        
        // {
        //   icon: "mdi-file-document-box-multiple-outline",
        //   text: "Zlecenia",
        //   link: "/orders"
        // },
        //  {
        //    icon: "mdi-file-document-box-multiple-outline",
        //    text: "Testy API",
        //    link: "/tests"
        //  },

        // {
        //   icon: "mdi-mail",
        //   text: "Jakas tabela",
        //   link: "/complaints"
        // },

        // {
        //   icon: "mdi-lifebuoy",
        //   text: "Pomoc",
        //   link: "/NewComplaint"
        // }
      ];
    },
    rightMenuItems: function() {
      return [
       //  {
       //    icon: "mdi-key-change",
       //    text: this.$t("Menu.rightMenu.ChangePassword"),
       //  }
      ];
    }
  },
  watch: {
     oldPassword: {
       handler: function() {
         this.disableBtnChangePassword = !this.$refs.ResetPasswordForm.validate();
       },
       deep: true
     },
     newPassword: {
       handler: function() {
        this.disableBtnChangePassword = !this.$refs.ResetPasswordForm.validate();
       },
       deep: true
     },
     confirmPassword: {
       handler: function() {
        this.disableBtnChangePassword = !this.$refs.ResetPasswordForm.validate();
       },
       deep: true
     },
     countDown () {
        if (this.countDown > 9) { this.countDownStr = "00:" + this.countDown; } else { this.countDownStr = "00:0" + this.countDown; }
      }
  },
  methods: {
    handleOrientationChange() {
      window.Store.dispatch("screenOrientation");
    },
    inicials(str) {
      var result = "";
      if (str.length > 0) {
        // jeśli niepuste
        if (str.length < 3) {
          // sprawdz czy dł 1 lub 2
          return (result = str); // i wróć niezmieniony
        } else {
          // jeśłi dłuższy niż 2
          if (!str.search(" ")) {
            result = str.substring(0, 2);
          } //sprawdz czy ma spacje, jeśli nie zwróć tylo 2 znaki
          else {
            var namesTable = str.split(" "); //jeśli ma spacje, podziel go na człony
            for (var i = 0; i < namesTable.length; i++) {
              result += namesTable[i].substring(0, 1); // z każdego członu weź tylko pierwszy znak
            }
          }
        }
      } else result = "- -"; // jeśli jest pusty zwróć 2 znaki -

      return result.substring(0, 3); // jeśli było by więcej członów, ogranicz inicjały do 3 liter
    },
    getCurrentUser() {
      this.customer.personName = window.Store.getters.getCurrentUser.personName;
      this.customer.email = window.Store.getters.getCurrentUser.email;
      this.customer.permissions = window.Store.getters.getPriviliges;
    },
    moveTo(link) {
      if (link) this.$router.push(link);
    },
    menuOn() {
      this.menu = true;
    },
    logout() {
      window.Store.dispatch("logout");
      location.reload();
    },
    changePassword() {
      this.dialogChangePassword = true;
    },
    
    setTimerToken: function() {
      this.tokenTimer = setTimeout(this.warningMessage, 10 * 60 * 1000);
    },
    resetTimerToken: function() {
      clearTimeout(this.tokenTimer);
      this.setTimerToken();
    },
    warningMessage: function() {
      this.refreshToken();
      this.resetTimerToken();
    },

    extendSession: function() {
      this.events.forEach(function (event) {
        window.addEventListener(event, this.extendSession)
      }, this);
      var sessionEndTime = new Date();
      sessionEndTime.setMinutes(sessionEndTime.getMinutes() + 10);
      this.$cookies.set("TPSessionTime", sessionEndTime);
      clearTimeout(this.logoutTimer);
      this.setTimerSessionExpired();
    },

    setTimerSessionExpired: function() {
      this.sessionExpiredToken =  setTimeout(() => {
          var remainedTime = new Date(this.$cookies.get("TPSessionTime")) - new Date();
          if (Math.round(remainedTime / 60 / 1000)==1){
            clearTimeout(this.logoutTimer);
            this.warningMessageLogout();
          }
          else {
            this.setTimerSessionExpired();
          }
      }, 1000)
    },

    // resetTimerSessionExpired: function() {
    //   clearTimeout(this.sessionExpiredToken);
    //   this.setTimerSessionExpired();
    // },
    
    warningMessageLogout: function() {
      this.events.forEach(function (event) {
        window.removeEventListener(event, this.extendSession)
      }, this);
      clearTimeout(this.sessionExpiredToken);
      this.countDown = 59;
      this.setCountDownLogoutTimer();
      this.dialogExpiredSession = true;
    },

    setCountDownLogoutTimer() {
        if(this.countDown > 0) {
           this.logoutTimer = setTimeout(() => {
                this.countDown -= 1
                this.setCountDownLogoutTimer()
                if (this.countDown == 0) {
                  this.logout();
                }
            }, 1000)
        }
    },

    BtnExtendSessions() {
      clearTimeout(this.logoutTimer);
      this.extendSession();
      this.dialogExpiredSession = false;
    },

    async BtnSendPasswordReset(){
      this.loadingBtn = true;
      const NewPasswordData = {
        newPassword: this.newPassword,
        currentPassword: this.oldPassword        
      };
      await window.Store.dispatch("newPassword", NewPasswordData)
        .then(response => {
          this.snack = true;
          this.snackColor = "success";
          this.snackText = "Hasło zostało zmienione";
          this.dialogChangePassword = false;
          this.Answer = response;
          this.loadingBtn = false;
        })
        .catch(errors => {
          this.snack = true;
          this.snackColor = "error";
          this.snackText = "Bląd podczas zmieniania hasła";
          this.dialogChangePassword = false;
          this.Answer = errors;
          this.loadingBtn = false;
        });
    },
    async refreshToken(){
      await window.Store.dispatch("refreshToken")
        .then(response => {
          this.Answer = response;
        })
        .catch(errors => {
          this.Answer = errors;
        });
    }
  },
  beforeCreate() {
      var sessionEndTime = new Date();
      sessionEndTime.setMinutes(sessionEndTime.getMinutes() + 10);
      this.$cookies.set("TPSessionTime", sessionEndTime);
  },
  mounted() {
    this.events.forEach(function (event) {
      window.addEventListener(event, this.extendSession)
    }, this);

    window.Store.dispatch("screenOrientation");

    this.getCurrentUser();
    this.setTimerToken();
    this.setTimerSessionExpired();
    clearTimeout(this.logoutTimer);
  },
};
</script>
